import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';

import EditableDataTable from '../../_Shared/DataTables/EditableDataTable';
import SlideTransition from '../../_Shared/Transitions/SlideTransition';
import BudgetLineSettings from './BudgetLineSettings';
import BudgetLineExternalMaps from './BudgetLineExternalMaps';

const moment = require('moment');
const styles = theme => ({
    appBar: {
        position: 'relative'
    },
    flex: {
        flex: 1
    },
    tabRoot: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper
    }
});
const uuidv4 = require('uuid/v4');

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

class BudgetLineEditor extends React.Component {

    state = {
        activeTab: 0,
        anchorEl: null,
        budgetLine: this.props.budgetLine,
        flight: {},
        externalMap: {},
        action: true,
        message: null,
        count: 0
    };

    componentDidMount() {
        const { budgetLine } = this.state;
        const { campaign: { layers } } = this.props;
        if (layers.length === 1 && !budgetLine.layerId) {
            this.setState({ budgetLine: Object.assign({}, budgetLine, { layerId: layers[0].key }) });
        }
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    handleChange = (event, activeTab) => {
        this.setState({ activeTab });
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { budgetLine: Object.assign({}, prevState.budgetLine, { [name]: value }) }
        });
    }

    saveBudgetLine = () => {
        const { budgetLine, budgetLine: { externalMaps } } = this.state;
        let aux = [];

        let map = Object.assign([], externalMaps);
        map.forEach((external_map_item, index) => {
            let split = '';
            if (external_map_item.externalId.indexOf(' ') > -1) split = external_map_item.externalId.split(' ');
            else split = external_map_item.externalId.split(',');

            split.forEach((split_item, index) => {
                let externalMap = {
                    budgetLineId: budgetLine.id,
                    providerId: external_map_item.providerId,
                    flightId: external_map_item.flightId,
                    externalId: split_item,
                    externalField: external_map_item.externalField
                };
                aux.push(externalMap);
            });
        });

        let valid = true;
        budgetLine.flights.forEach(element => {
            if (element.startDate > element.endDate) {
                valid = false;
            }
        });

        if (valid) {
            let assignedBudgetLine = Object.assign({}, budgetLine, { externalMaps: aux });
            this.props.onBudgetLineAdded(assignedBudgetLine);
            this.props.onClose();
        } else {
            this.setState({ message: 'Flights start date has to be before end date' });
            this.startTimer();
        }
    }

    selectFlight = flight => {
        this.setState({ flight });
    }

    addFlight = () => {
        const { budgetLine } = this.state;

        let flight = {
            id: uuidv4().replace(/-/g, ''),
            startDate: moment().add(1, 'day'),
            endDate: moment().add(7, 'day'),
            budget: 0, unitCost: 0, estimatedUnits: 0
        };

        this.setState(() => {
            let nextDate = this.getDateAvailable(budgetLine);
            if (nextDate !== moment().format('L')) {
                flight.startDate = moment(nextDate.add(1, 'day'));
                flight.endDate = moment(nextDate.add(7, 'day'));
            }

            return {
                budgetLine: Object.assign({}, budgetLine, { flights: [...budgetLine.flights, flight] })
            }
        });
    }

    editFlight = (row, rowIndex) => {
        this.setState((prevState, state) => {
            const { budgetLine } = prevState;
            if (this.dateIsValid(budgetLine, row)) {
                let aux = Object.assign([], budgetLine.flights);
                aux.splice(rowIndex, 1, row);
                return { budgetLine: Object.assign({}, budgetLine, { flights: aux }) }
            } else {
                this.startTimer();
                return { message: 'Date range invalid, you cannot have dates overlapping' }
            }
        });
    }

    tick = () => {
        this.setState({ count: (this.state.count + 1) });
        if (this.state.count === 5) {
            this.setState({ message: null, count: 0 });
            clearInterval(this.timer)
        }
    }

    startTimer = () => {
        clearInterval(this.timer)
        this.timer = setInterval(this.tick.bind(this), 1000)
    }

    deleteFlight = () => {
        this.setState(() => {
            const { budgetLine, flight } = this.state;
            return {
                budgetLine: Object.assign({}, budgetLine, { flights: budgetLine.flights.filter(x => x.id !== flight.id) }),
                anchorEl: null
            }
        });
    };

    dateIsValid = (budgetLine, newFlight) => {
        let valid = true;
        let flights = budgetLine.flights.filter(x => x.id !== newFlight.id);
        flights.forEach((item, index) => {
            let start = moment(item.startDate);
            let end = moment(item.endDate);
            if (newFlight.startDate <= end && start <= newFlight.endDate) {
                valid = false;
            }
        });

        return valid;
    }

    getDateAvailable = (budgetLine) => {
        let dateMin = budgetLine.flights.length > 0 ? budgetLine.flights[0].startDate : moment().format('L');
        budgetLine.flights.forEach((item, index) => {
            if (moment(dateMin).isSameOrBefore(item.endDate)) {
                dateMin = item.endDate;
            }
        });

        return moment(dateMin);
    }

    selectExternalMap = externalMap => {
        this.setState({ externalMap });
    }

    addExternalMap = () => {
        let externalMap = { providerId: '', externalId: '', flightId: 'empty_flight', externalField: '' };
        this.setState(() => {
            const { budgetLine } = this.state;
            return {
                budgetLine: Object.assign({}, budgetLine, { externalMaps: [...budgetLine.externalMaps, externalMap] })
            }
        });
    }

    editExternalMap = (budgetLine) => {
        this.setState({ budgetLine });
    }

    deleteExternalMap = () => {
        const { onDeleteExternalMap }  = this.props;        
        this.setState(() => {
            const { budgetLine, externalMap } = this.state;
            onDeleteExternalMap(externalMap);
            return {
                budgetLine: Object.assign({}, budgetLine, { externalMaps: budgetLine.externalMaps.filter(x => x.externalId !== externalMap.externalId) }),
                anchorEl: null
            }
        });
    };

    render() {
        const { classes, onClose, campaign, websites, providers } = this.props;
        const { activeTab, budgetLine, anchorEl, action, message } = this.state;

        return (<Dialog fullScreen open={true} onClose={onClose} TransitionComponent={SlideTransition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={onClose} aria-label="Close"><CloseIcon /></IconButton>
                            <Typography variant="title" color="inherit" className={classes.flex}>{this.props.title}</Typography>
                            <Button color="inherit" onClick={this.saveBudgetLine}>Save</Button>
                        </Toolbar>
                    </AppBar>
                    <div className={classes.tabRoot}>
                        <AppBar color="default" position="static">
                            <Tabs value={activeTab} onChange={this.handleChange}>
                                <Tab label="Settings" />
                                <Tab label="External Maps" />
                            </Tabs>
                        </AppBar>
                        {
                            message &&
                            <AppBar position="static" style={{ backgroundColor: '#ff0000' }}>
                                <Toolbar>
                                    <Typography variant="title" color="inherit">{message}</Typography>
                                </Toolbar>
                            </AppBar>
                        }
                        {
                            activeTab === 0 &&
                            <TabContainer>
                                <Grid container spacing={40}>
                                    <BudgetLineSettings budgetLine={budgetLine} campaign={campaign} websites={websites} handleInputChange={this.handleInputChange} />
                                    <Grid item xs={9}>
                                        {
                                            <EditableDataTable columns={[
                                                { label: 'Start Date', field: 'startDate', type: 'datetime' },
                                                { label: 'End Date', field: 'endDate', type: 'datetime' },
                                                { label: 'Budget', field: 'budget', type: 'number' },
                                                { label: 'Unit Cost', field: 'unitCost', type: 'number' },
                                                { label: 'Est. Units', field: 'estimatedUnits', type: 'number' }
                                            ]} anchorEl={anchorEl}
                                                rows={budgetLine.flights.sort((a, b) => { return a.startDate - b.startDate; })} toggleRowMenu={this.toggleRowMenu}
                                                onElementSelect={this.selectFlight} action={action} onCloseToggleRowMenu={this.closeToggleRowMenu}
                                                onActionClick={this.addFlight} onEdit={this.editFlight}>
                                                <MenuItem onClick={this.deleteFlight}>
                                                    <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                                                    <ListItemText inset primary="Delete" />
                                                </MenuItem>
                                            </EditableDataTable>
                                        }
                                    </Grid>
                                </Grid>
                            </TabContainer>
                        }
                        {
                            activeTab === 1 &&
                            <TabContainer>
                                <Grid container>
                                    <BudgetLineExternalMaps budgetLine={budgetLine} providers={providers} anchorEl={anchorEl} toggleRowMenu={this.toggleRowMenu}
                                        selectExternalMap={this.selectExternalMap} action={action} addExternalMap={this.addExternalMap}
                                        closeToggleRowMenu={this.closeToggleRowMenu} deleteExternalMap={this.deleteExternalMap} onEditExternalMap={this.editExternalMap} />
                                </Grid>
                            </TabContainer>
                        }
                    </div>
                </Dialog>
        );
    }
}

BudgetLineEditor.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BudgetLineEditor);


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/MediaPlan/BudgetLineEditor.js